import { HttpTransport, IResponse } from '@estee/elc-http-transport';
import { captureMessage } from '@sentry/react';
import { IRpcPostBody, IRpcResponse } from './IRpcAPI';
import { IToken } from '~api/CartAPI/ICartApiSdk';
import { Throttle, getCsrfTokenFromCookie } from '~api/utils/utils';

const httpTransport = new HttpTransport();

const requiredHeaders = {
    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'x-vulcan-proxy-eligible': true
};

const path = '/rpc/jsonrpc.tmpl';

export const tokenRPC = async () => {
    const body = new URLSearchParams();
    body.append('JSONRPC', JSON.stringify([{ method: 'csrf.getToken', params: [{}] }]));

    return httpTransport
        .post({ headers: requiredHeaders, url: `${path}?dbgmethod=csrf.getToken`, body })
        .then(({ data }) => (data as IRpcResponse<IToken['token']>[])[0]?.result?.value?.token);
};

export const getToken = new Throttle(tokenRPC);

export const makeRPCPost = async <T, R>(rpcBody: IRpcPostBody<T>[], token: string = '') => {
    const [{ method = '' }] = rpcBody;
    const url = method ? `${path}?dbgmethod=${method}` : path;
    const body = new URLSearchParams();

    let fetchedToken = '';
    const storedToken = token || getCsrfTokenFromCookie();

    if (!storedToken) {
        fetchedToken = await getToken.execute();
        document.cookie = `csrftoken=${fetchedToken}`;
    }

    const _token = storedToken || fetchedToken;

    const _rpcBody = rpcBody.map((_body) => ({
        ..._body,
        params: _body.params.map((params) => ({ ...params, _TOKEN: _token }))
    }));

    body.append('JSONRPC', JSON.stringify(_rpcBody));

    return httpTransport
        .post<R[]>({
            url,
            body,
            headers: {
                ...requiredHeaders,
                'x-csrf-token': _token
            }
        })
        .catch((error) => {
            captureMessage('RPC API [makeRPCPost] - call failed', {
                level: 'warning',
                tags: { method, rpc: true, custom: true },
                extra: {
                    error,
                    method,
                    url: url,
                    elcelerate: window.navigator.userAgent.match(/elcelerate/i)?.[0],
                    user_agent: window.navigator.userAgent,
                    params: _rpcBody[0].params[0]
                }
            });

            return {} as IResponse<R[]>;
        });
};
